<template>
<div class="ISgetJobJianYiDetail mainContainer">
  <projectInfoJianYi :project="project"/>
</div>
</template>

<script>
import projectInfoJianYi from '@views/components/projectInfoJianYi'
import { getSimpleProjectInfo } from '@api/project'
export default {
  name: 'ISgetJobJianYiDetail',
  components: {
    projectInfoJianYi
  },
  data () {
    return {
      project: {}
    }
  },
  created () {
    this.getProjectInfo()
  },
  methods: {
    getProjectInfo () {
      getSimpleProjectInfo({
        id: this.$route.query.projectId
      }).then(res => {
        if (res.data.code === 200) {
          this.project = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
